<template>
    <div class="spinner" :key="'loading-spinner'">
        <div class="spinner-image"></div>
        <div class="spinner-text"><strong>Augenblick bitte...</strong></div>
    </div>
</template>
<script>
    export default {
        name: 'Spinner',
    }
</script>
<style scoped>

</style>